import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import TransformComponent from '../../../Component/Transform';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import Point from '../../../Utility/Point';
import { MathHelper } from '../../../Utility/MathHelper';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardSystem from '../../Card/CardSystem';
import Interactable from '../../../Component/Interactable';
import { CARD_STACK_OFFSET } from '../../../Constants/InGame';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';
import CardComponent, { DEFAULT_CARD_SCALE } from 'Component/Level/Card';

interface ICardPlusFiveMeta {
    system: CardSystem;
    targetCards: BaseCard[];
    stackContainer: GameObject;
}

export class CardPlusStreak extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: ICardPlusFiveMeta
    ): IterableIterator<number> {
        StreakBar.instance.playRewardAnimation();

        const icon: GameObject = StreakBar.instance.reward;
        const duration: number = 1000;

        // End points to use in cubic bezier function.
        const p3: Point = new Point(-600, 0);
        const p4: Point = new Point(CARD_STACK_OFFSET, 0); // Final position (stack).

        if (meta.targetCards.length === 1) {
            PlaySound('cardstreak-1');
        } else {
            PlaySound('cardstreak-2&3');
        }

        for (let i = 0; i < meta.targetCards.length; i++) {
            const card = meta.targetCards[i];
            // Add card as giftbox children to get its position.
            const cardTransform = card.getComponent(TransformComponent);
            const cardComponent = card.getComponent(CardComponent);
            cardComponent.skipStackAlign = true;
            card.getComponent(Interactable).enabled = false;
            icon.addChild(card);
            cardTransform.position.set(0);
            meta.stackContainer.addChild(card);

            const p1: Point = cardTransform.position.clone() as Point; // Start position.
            const p2: Point = new Point(p1.x + 450, p1.y - 200);

            cardTransform.scale.set(0.25, 0.25);
            cardTransform.rotation = Math.PI * 2;
            card.getComponent(Renderable).visible = true;

            const progressTween = this.getTween({ progress: 0 });
            progressTween
                .to({ progress: 1 }, duration)
                .onUpdate(t => {
                    const xy = MathHelper.cubicBezier(
                        t.progress,
                        p1,
                        p2,
                        p3,
                        p4
                    );
                    cardTransform.position.set(xy.x, xy.y);
                })
                .start(this.elapsedTime);

            const rotationTween = this.getTween(cardTransform);
            rotationTween.to({ rotation: 0 }, duration).start(this.elapsedTime);

            const scaleTween = this.getTween(cardTransform.scale);
            scaleTween
                .to({ x: DEFAULT_CARD_SCALE, y: DEFAULT_CARD_SCALE }, duration)
                .start(this.elapsedTime)
                .onComplete(() => {
                    cardComponent.skipStackAlign = false;
                    this.emit('PlusStreakCardAdded', card, i);
                });

            yield* delay(100);
        }

        yield* delay(duration - 100);
    }
}
